// extracted by mini-css-extract-plugin
module.exports = {"artist":"SelectArtistRow-artist-3amxh"};